// 'use client';
// import PriceDisplay, { TCountryId } from '@/components/sarComponent';
// import { Progress } from '@/components/ui/progress';
// import Typography from '@/components/ui/typography';
// import { useTranslations } from 'next-intl';
// import React, { FC } from 'react';

// type Props = {
//   totalPrice: number;
//   minimumOrderAmount: number;
//   countryId: TCountryId;
// };

// const MinimumOrderAmount: FC<Props> = ({ minimumOrderAmount, totalPrice, countryId }) => {
//   const t = useTranslations('cart');

//   const theNumberToReachTotalProce = minimumOrderAmount - totalPrice;
//   const thePrecentage = (theNumberToReachTotalProce / minimumOrderAmount) * 100;

//   if (totalPrice >= minimumOrderAmount)
//     return (
//       <div className="mt-4">
//         <Typography color={'success'} variant={'body2'} weight={'semibold'}>
//           {t('YouAreGoodToGO')}
//         </Typography>
//         <Progress value={100} className="mt-2 h-1.5" variant="success" />
//       </div>
//     );

//   return (
//     <div className="mt-4">
//       <Typography
//         component={'div'}
//         variant={'body2'}
//         color={'warning'}
//         weight={'semibold'}
//         className="flex items-center gap-1"
//       >
//         {t('AlmostThere')}
//         <PriceDisplay size="small" countryId={countryId} price={theNumberToReachTotalProce} />{' '}
//         {t('AwayFromTheMinimum')}
//       </Typography>

//       <Progress value={thePrecentage} className="mt-2 h-1.5" variant="warning" />
//     </div>
//   );
// };

// export default MinimumOrderAmount;
'use client';
import PriceDisplay, { TCountryId } from '@/src/components/sarComponent';
import { Progress } from '@/src/components/ui/progress';
import Typography from '@/src/components/ui/typography';
import { useTranslations } from 'next-intl';
import React, { FC } from 'react';

type Props = {
  totalPrice: number;
  minimumOrderAmount: number;
  countryId: TCountryId;
};

const MinimumOrderAmount: FC<Props> = ({ minimumOrderAmount, totalPrice, countryId }) => {
  const t = useTranslations('cart');

  // Calculate remaining amount needed to reach minimum
  const remainingAmount = Math.max(0, Number((minimumOrderAmount - totalPrice).toFixed(2)));

  // Calculate percentage progress (capped between 0-100)
  const progressPercentage = Math.min(100, Math.max(0, (totalPrice / minimumOrderAmount) * 100));

  if (totalPrice >= minimumOrderAmount)
    return (
      // <div className="mt-4">
      //   <Typography color={'success'} variant={'body2'} weight={'semibold'}>
      //     {t('YouAreGoodToGO')}
      //   </Typography>
      //   <Progress value={100} className="mt-2 h-1.5" variant="success" />
      // </div>
      null
    );

  return (
    <div className="mt-4">
      <Typography
        component={'div'}
        variant={'body2'}
        color={'warning'}
        weight={'semibold'}
        className="flex items-center gap-1"
      >
        {t('AlmostThere')}
        <PriceDisplay size="small" countryId={countryId} price={remainingAmount} />{' '}
        {t('AwayFromTheMinimum')}
      </Typography>

      <Progress value={progressPercentage} className="mt-2 h-1.5" variant="warning" />
    </div>
  );
};

export default MinimumOrderAmount;
